import { defineComponent as _defineComponent } from 'vue'
import JobInventoryEditField from '@/components/tickets/JobInventoryEditField.vue'
import { computed, nextTick, ref } from 'vue'
import { createNamespacedHelpers } from 'vuex-composition-helpers'
import Inventory from '@/models/inventory'
import { NormalizedInventory } from '@/store/modules/assets'
import VsHeading from '@/components/vision/VsHeading.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import VsText from '@/components/vision/VsText.vue'
import VsButton from '@/components/vision/VsButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationInventoryEdit',
  props: {
    inventories: null
  },
  emits: ["update-inventory", "remove-inventory", "add-inventory"],
  setup(__props: any, { emit }: { emit: ({
  (
    e: 'update-inventory',
    inventorySubTypeId: number,
    inventory: Inventory
  ): void
  (e: 'remove-inventory', inventorySubTypeId: number): void
  (e: 'add-inventory'): void
  (e: 'update-inventory', object): void
  (e: 'remove-inventory', inventorySubTypeId: number | null): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  inventories: Inventory[]
}



const { getNormalizedInventories } = createNamespacedHelpers(
  'assets'
).useGetters(['getNormalizedInventories'])

const availableInventoryOptions = computed<NormalizedInventory[]>(() => {
  return getNormalizedInventories.value
    .filter((inv) => inv.assetConditions.length > 0)
    .map((inv) => ({
      ...inv,
      assetConditions: inv.assetConditions.map((ac) => ({
        ...ac,
        selected: props.inventories.some((x) => x.inventorySubTypeId === ac.id),
      })),
    }))
})


const inventoryEditField = ref()

const focusEmptyInventoryAutoComplete = () => {
  const inventoryIndex: number = props.inventories.findIndex(
    (i) => i.inventorySubTypeId === null
  )
  const fieldRef = inventoryEditField.value[inventoryIndex]
  fieldRef?.focusInventoryType()
}

const addInventory = () => {
  if (props.inventories.some((i) => i.inventorySubTypeId === null)) {
    focusEmptyInventoryAutoComplete()
  } else {
    emit('add-inventory')
    nextTick(() => {
      focusEmptyInventoryAutoComplete()
    })
  }
}

const updateInventory = (
  inventorySubTypeId: number | null,
  inventory: Inventory
) => {
  emit('update-inventory', {
    inventorySubTypeId,
    inventory,
  })
}

const removeInventory = (inventorySubTypeId: number | null) => {
  emit('remove-inventory', inventorySubTypeId)
}

return { __sfc: true,props, getNormalizedInventories, availableInventoryOptions, emit, inventoryEditField, focusEmptyInventoryAutoComplete, addInventory, updateInventory, removeInventory, JobInventoryEditField, VsHeading, VsWrapper, VsText, VsButton }
}

})